import { render, staticRenderFns } from "./IconJzjx.vue?vue&type=template&id=95264566"
import script from "./IconJzjx.vue?vue&type=script&lang=js"
export * from "./IconJzjx.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports